/* eslint-disable max-len */

export default {
  lang: "Portuguese",
  homeScreen: {
    title: "Capital Mundial dos Parques Temáticos",
    stayConnected: "Continue conectado",
    comingSoon: "Em breve",
    messages: "Mensagens",
  },
  notification: {
    newAndNow: "Novidades!",
    alert: "Alerta",
    message: "Mensagem",
    contest: "Concurso",
    badge: "Novo Distintivo",
    "content-update": "Atualização de Conteúdo",
    events: "Eventos",
  },
  loginScreen: {
    version2: {
      homeTitle:
        "Vamos ver se conseguimos encontrar um perfil para si no nosso sistema.",
      homeTitleSub:
        "Introduza o endereço de correio eletrónico que utiliza habitualmente para iniciar sessão nos programas de formação.",
      noAccount:
        "Não foi encontrada nenhuma conta ({email}), tente com outro e-mail ou crie uma conta agora.",
      continueButton: "Continuar",
      success:
        "Atualização bem sucedida da sua conta! Em breve será redireccionado para a página inicial.",
      successNewAccount:
        "Para concluir o seu registo, receberá um e-mail de confirmação para verificar a sua conta.",
      loginButton: "Iniciar sessão",
      matchFound:
        "Encontrámos uma correspondência, por favor preencha a sua palavra-passe para continuar.",
      magicLink:
        "Inicie sessão através de uma ligação no seu correio eletrónico:",
      magicLinkButton: "Pedir Magic Link",
      magicLinkTitle:
        "Receba um link direto enviado para o seu e-mail que o inscreverá instantaneamente.",
      otherEmailButton: "Enviar",
      title:
        "Reserve um momento para preencher todas as informações abaixo, uma vez que estas preencherão o seu perfil pessoal e as informações de contacto.",
      titleIndustry:
        "Reserve um momento para preencher todas as informações abaixo, uma vez que estas preencherão o seu perfil pessoal e as informações de contacto.",
      register: "Criar uma conta",
      agent: "Consultor de viagens",
      visitor: "Visitante do sector",
      step1: "Etapa 1: Tipo de utilizador",
      step2: "Passo 2: Criar uma conta",
      step3: "Passo 3: Criar o seu perfil",
      marketingOptIn:
        "Tem a certeza de que não está interessado em manter-se ligado à equipa de comércio de viagens deste programa?",
      optIn: "Sim, estou interessado",
      optOut: "Não estou interessado",
      step2Sub1: "Fale-nos de si",
      step2Sub2: "Fale-nos do seu negócio",
      privacyHead: "PREFERÊNCIAS DE COMUNICAÇÃO",
      privacySub:
        "Assinale as caixas abaixo para garantir que recebe comunicações importantes da equipa de comércio de viagens do fornecedor (actualizações e anúncios de produtos, recompensas, incentivos, FAMs, etc.) e iniciativas de apoio às vendas e redes de comércio de viagens da TravPRO Mobile.",
      privacy:
        "Protegemos a sua privacidade e nunca vendemos, utilizamos indevidamente ou traímos a sua confiança.",
      store: "Descarregue facilmente este programa na sua loja de aplicações:",
      powered: "POTENCIADO POR",
      toastMessage: {
        forgotSuccess:
          "Enviámos por e-mail a sua ligação para redefinição da palavra-passe! Será redireccionado para a página de início de sessão dentro de 10 segundos.",
        emailNotExisting:
          "O endereço de correio eletrónico que introduziu não existe.",
        magicLinkMessage: "Aguarde, estamos a registá-lo neste momento.",
        magicLinkError:
          "Não foi possível encontrar a sua conta na nossa base de dados. Inicie sessão manualmente. Será redireccionado em 10 segundos.",
        magicLinkError1:
          "Não foi possível encontrar um token válido. Inicie sessão ou solicite uma nova ligação mágica. Se o problema persistir, contacte-nos em: info@travpromobile.com.",
        magicLinkError2:
          "Não foi possível encontrar a sua conta na nossa base de dados. Inicie sessão manualmente. Será redireccionado em 10 segundos.",
        magicLinkSuccess:
          "Verifique o seu e-mail em {email}. Tem uma hiperligação mágica que o vai registar.",
        magicLinkErrorWait:
          "Aguarde 5 minutos entre pedidos de ligações mágicas.",
        emailNotFoundError:
          "O endereço de correio eletrónico que introduziu não se encontra nos nossos registos. Verifique se há erros ortográficos ou crie uma conta.",
      },
      errors: {
        zipCodeNotFound: "Código postal não encontrado, tente novamente",
        zipCodeOnlyNumbers: "O ZipCode só pode conter números",
        password: "Introduzir uma palavra-passe",
        passwordNotMatching: "As palavras-passe introduzidas não correspondem",
        passwordTooShort: "A palavra-passe tem de ter pelo menos 8 caracteres",
        emailExists:
          "Este endereço de correio eletrónico já existe ou é inválido. Tente com outro endereço de correio eletrónico ou inicie sessão na sua conta.",
        fillInAllFields: "Preencher todos os campos obrigatórios",
        fillInEmail: "Preencha o seu e-mail.",
        emailNotExisting:
          "O endereço de correio eletrónico que introduziu não existe.",
      },
      fields: {
        forgotSubCopy:
          "Esqueceu-se da sua palavra-passe e pretende alterá-la? ",
        forgotSubCopy2:
          "Pretende ignorar totalmente a palavra-passe? Enviar-lhe-emos um e-mail com uma ligação mágica que o ligará automaticamente ao programa.",
        city: "Cidade",
        companyName: "Nome da empresa",
        role: "O seu papel",
        description: "Qual descreve melhor a atividade da sua empresa?",
        country: "País",
        password: "Palavra-passe",
        passwordRegister: "Escolha a palavra-passe (mínimo de 8 caracteres)",
        passwordConfirm: "Confirmar a palavra-passe",
        firstName: "Nome próprio",
        lastName: "Apelido (Família)",
        agency: "Nome da sua agência",
        title: "A sua função (selecionar uma)",
        company: "Nome da empresa",
        select: "Seleccione uma opção abaixo",
        state: "Estado",
        province: "Província/Região/Estado",
        zipCode: "Código Postal",
        postalCode: "Código Postal",
        affiliate: "A que grupo pertence a sua agência PRINCIPAL?",
        hostAgency: "A sua agência de acolhimento?",
        executive: "Executivo",
        management: "Gestão",
        marketing: "Marketing",
        sales: "Vendas",
        coordinator: "Coordenador",
        opt: "Mantenha-se ligado à equipa de comércio de viagens deste programa e receba actualizações.",
        optMarketing:
          "Mantenha-se em contacto com a TravPRO relativamente a programas e eventos semelhantes.",
        retail: "Frente de loja de retalho",
        home: "Agente domiciliário",
        independent: "Contratante independente",
        host: "Agência de acolhimento",
        call: "Call Center ou agência baseada na Web",
        other: "Outros",
        describes: "O que melhor descreve a sua atividade e a da sua agência?",
      },
    },
    forgot: "Esqueceu a senha",
    title:
      "Programa de capacitação de vendas e treinamento de agentes de viagens",
    welcome: {
      headerTop: "Bem-vindo à",
      headerBottom: "Orlando Travel Academy",
    },
    sellingPoints: {
      0: "Ganhe 2 créditos CEU do Travel Institute",
      1: "Cinco (5) Capítulos Fundamentais para Ganhar Diploma",
      2: "Diretório de parceiros e vitrines para consumidores",
      3: "Colateral de marketing pronto para uso",
      4: "Recursos de vendas integrados de alto impacto",
      5: "Dicas e promoções",
      6: "Notícias e atualizações oportunas",
    },
    emailPrompt:
      "Insira seu endereço de e-mail e senha para confirmar que você é um agente de viagens.",
    tAndC: {
      agree: "Ao continuar, você concorda com a nossa",
      privacyPolicy: " política de privacidade ",
      and: "e ",
      termsConditions: "termos e condições",
    },
    fields: {
      agency: "Agência",
      email: "E-mail",
      password: "Senha *",
      passwordConfirm: "Confirme a sua senha *",
      firstName: "Nome *",
      lastName: "Sobrenome *",
      city: "Cidade *",
      agencyName: "Nome da agência *",
      stateProvince: "Estado/Província *",
      required: "Obrigatório",
      invalidEmail: "Endereço de e-mail inválido",
      opt: "Fique por dentro! Sim, gostaria de receber comunicações da Orlando Travel Academy para me manter informado sobre notícias, eventos, incentivos, FAMs e muito mais!",
      complete: "Passo 2: Complete seu perfil",
      tell: "Conte-nos sobre você",
      title: "Título da empresa *",
      host: "Nome da agência anfitriã",
      country: "País / Região",
      select: "Por favor, selecione uma opção abaixo",
      header2: "Quais segmentos você vende principalmente?",
      step2: "Descreva seu negócio",
      leisure: "Lazer",
      corporate: "Corporativo",
      group: "Grupo",
      affiliate: "Qual é a sua afiliação principal?",
      forgot: "Repor a palavra-passe",
    },
    forgot:
      "Esqueceu-se da sua palavra-passe? Clique no botão abaixo e enviar-lhe-emos um e-mail para redefinir a sua palavra-passe.",
    noAgent: {
      noAgentButton: "Não sou um conselheiro",
      title: "Agradecemos pelo seu interesse na Orlando Travel Academy.",
      messageWeb:
        "O conteúdo deste site é exclusivo para agentes de viagens. Para saber mais sobre Orlando, acesse:",
      messageMobile:
        'Alguns conteúdos deste aplicativo são exclusivos para agentes de viagens, mas fique à vontade para ver uma prévia do que o aplicativo tem a oferecer clicando em "Continuar".',
      continue: "Continuar",
      visitWebsite: "Visitar site",
    },
    newUser: "Novo usuário",
    register: "Cadastrar-se",
    registered: "Este e-mail já está cadastrado",
    forgots: "Esqueci minha senha",
    header:
      "Por favor, reserve um momento para preencher todas as informações abaixo, pois é isso que preencherá seu perfil e informações de contato.",
    step1: "Passo 1: Preencha seu endereço de e-mail e escolha uma senha.",
  },
  welcomeScreen: {
    title: "Boas-vindas à Orlando Travel Academy",
    helloUser: "Olá, {{name}}",
    hello: "Olá,",
    fromAgency: "da {{agency}}",
    notUser: "Você não é {{name}}?",
    introOnline:
      "Faça o treinamento on-line ou pré-carregue o conteúdo para que esteja sempre disponível para uso off-line!",
    introOffline:
      "Você já tem a versão mais recente pré-carregada. Comece a treinar ou vender a qualquer hora, em qualquer lugar!",
    startTraining: "Começar a aprender",
    continueTraining: "Continuar aprendendo",
    graduated: "Parabéns!",
    downloader: {
      preload: "Pré-carregar",
      stop: "parar",
      init: "Inicializando...",
      lastUpdate: "Última atualização:",
    },
  },
  trainingScreens: {
    start: "Iniciar",
    continue: "Continuar",
    review: "Revisar",
    restart: "Reiniciar",
    durationInMinutes: "{number} minutos",
    percentageComplete: "{number}% concluído",
    unlock:
      "Libere este capítulo após concluir o capítulo de treinamento {number}.",
    unlockSubtitle:
      "Libere mais capítulos após concluir os capítulos de treinamento.",
    allUnlocked: "Você liberou todos os capítulos!",
    certificate: "Certificado",
    courseComplete: "Continuar",
    endReached: "Você chegou ao final",
    retainEnd:
      "Use a barra superior para navegar neste capítulo ou pressione o botão Voltar para retornar à visão geral.",
    watchListenRead: "Assista, ouça e leia mais",
    trouble:
      "Parece que você está com problemas. Releia o conteúdo das páginas anteriores e tente novamente.",
    confirm: "Confirmar a sua resposta",
    choose: "Escolha uma resposta",
    skip: "Voltar >",
    viewAllTitle: "Dica do treinamento",
    viewAll:
      "Para prosseguir para a próxima página, clique nos ícones para visualizar o conteúdo complementar. Vídeos, mapas e outras informações úteis foram fornecidos para aprimorar seu treinamento e garantir que você alcance o status PRO.",
    fillBlanks: "Preencha os espaços em branco:",
    next: "Próxima pergunta",
    retry: "Tentar novamente",
    fastTrackText: {
      success:
        "Parabéns, você foi aprovado no curso Fast Track e liberou o restante do treinamento!",
      failed:
        "Infelizmente você não foi aprovado no curso Fast Track. Você pode retomar o treinamento para obter o seu certificado!",
    },
    fastTrack: "Seja uma Superestrela do turismo na Suíça!",
    fastTrackExplanation:
      'Basta fazer o teste das páginas a seguir para ter a chance de participar do FAM para a Suíça!<br><br><span style="font-weight: bold">Você encontrará todas as respostas para as perguntas do questionário das seguintes maneiras:</span><br><br>1. No conteúdo que você aprendeu nos módulos Europa de trem e Suíça <br><br>2. E nos seguintes sites:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">Revise esses recursos com atenção antes de fazer o teste! Somente aqueles com as pontuações mais altas terão a chance de serem convidados para o FAM.</span>',
    fastTrackButton:
      "Clique aqui para responder ao questionário de Superestrela da Suíça",
    grading: "Sua nota final é: {grade}%",
  },
  nav: {
    home: "Página inicial",
    train: "Aprender",
    learn: "Aprender",
    retain: "Guardar",
    directory: "Diretório",
    showRoom: "Demonstrações",
    showcases: "Demonstrações",
    offers: "Ofertas",
    promote: "Promover",
    sell: "Vender",
    info: "Informações",
    rewards: "Recompensas",
    media: "Mídias",
    favorites: "Favoritos",
    contact: "Contato",
    reportCard: "Ver certificado",
    accountSettings: "Configurações da conta",
    messages: "Mensagens",
    search: "Pesquisar",
  },
  contentHeaders: {
    specializations: "Especializações",
    train: "Aprender",
    retain: "Guardar",
    subapps: "Módulos do parceiro de Orlando",
    maintrainings: "A base",
    subtrainings: "A experiência",
  },
  pageDescriptions: {
    specializations:
      "Leve seu status de Especialista em Orlando para o próximo nível, completando esses capítulos para obter distintivos de especialização",
    train: "Instrua, engaje e se torne um especialista.",
    showroom: "",
    retain:
      "Parabéns por concluir seu treinamento! Você acabou de liberar o principal recurso para guardar os conhecimentos especializados e melhorar suas habilidades de vendas. Use essa área para responder corretamente a uma pergunta sobre um produto ou até mesmo improvisar uma apresentação de vendas a qualquer hora, em qualquer lugar e em qualquer dispositivo.",
    promote:
      "Compartilhe esses itens para despertar o interesse e iniciar uma conversa com clientes e possíveis clientes.",
    sell: "Responda às perguntas dos clientes e feche a venda como um profissional com recursos aprofundados e suporte de vendas direcionado.",
    favorites: "Confira o conteúdo que você salvou como favorito",
    search: "Revise todo o conteúdo",
    subapps: "",
    maintrainings:
      "Comece com as informações básicas sobre Orlando e onde seus clientes podem se hospedar.",
    subtrainings:
      "Conclua esses módulos sobre todas as coisas incríveis que os clientes podem fazer e ver em Orlando e receba seu certificado de Especialista oficial em Orlando.",
  },
  contact: {
    vp: "Vice-presidente de vendas do setor de viagens",
    na: "Diretor de vendas da indústria de viagens, América do Norte",
    emea: "Diretor de Vendas da Indústria de Viagens, EMEA",
    la: "Diretor de Vendas da Indústria de Viagens, América Latina",
  },
  general: {
    offerBig:
      "Com o seu status de especialista, vêm muitos benefícios, começando com ofertas exclusivas e descontos disponíveis apenas para você! Clique no botão de Ofertas na página inicial para começar a colher as recompensas de seus esforços.",
    badge: "Visualizar crachá",
    offerMessage: "Oferta de Ingresso Gratuito Legoland Florida",
    unlock: "Desbloqueie este item ao completar a seção Aprender",
    next: "Avançar",
    yes: "Sim",
    no: "Não",
    previous: "Voltar",
    submit: "Enviar",
    back: "Voltar",
    close: "Fechar",
    page: "Página",
    search: "Pesquisar",
    logIn: "Entrar",
    logOut: "Sair",
    viewItem: "Ver {type}",
    imageNotFound: "Imagem não encontrada",
    noResultsFor: "Nenhum resultado foi encontrado para: {{query}}",
    noFavorites: "Você ainda não tem favoritos.",
    noMessages: "Você ainda não recebeu mensagens!",
    resultsFor: "Resultados para: {{query}}",
    showAll: "Mostrar tudo",
    connectionError: "Erro de conexão",
    alreadyExists: "Já existe",
    pageNotFound: "404 Página Não Encontrada!",
    oops: "Ops...",
    overview: "Voltar para a visão geral",
    complete: "Continuar",
    courseComplete: "Capítulo concluído!",
    chapterComplete: "Capítulo concluído!",
    message: "{count} mensagem",
    messagePlural: "{count} mensagens",
    completion: "Complete a Fundação para desbloquear esse item.",
  },
  itemTypes: {
    image: "Imagem",
    brochure: "Coleção",
    layout: "Layout",
    web: "Website",
    pdf: "PDF",
    carousel: "Coleção",
  },
  questions: {
    dials: "Gire os botões giratórios para corresponder à resposta",
    fitb: "Preencha os espaços em branco",
    flip: "Altere o número para corresponder à resposta",
    multipleChoice: "Escolha as respostas corretas",
    slider: "Escolha a resposta correta usando o controle deslizante",
    map: "Responda à pergunta tocando no local certo no mapa",
    dropdown: "Escolha...",
    true: "Verdadeiro",
    false: "Falso",
  },
  reportCard: {
    download: "Baixar",
    email: "E-mail",
    print: "Imprimir",
  },
  cookies: {
    consent: "CONCORDAR",
    optout: "Recusar",
    settings: "Configurações de privacidade",
    message:
      "Você não nos informou suas preferências de privacidade de dados! Tudo bem, mas gostaríamos de oferecer a você a melhor experiência usando o Assistente de vendas.",
    disabled: "Parece que você desativou o uso de cookies.",
    use: "O aplicativo {{appName}} requer o uso de cookies para proporcionar a melhor experiência.",
    details: "Para que servem os cookies?",
    enable: "Veja como habilitar seus cookies {{here}}.",
    here: "aqui",
  },
  notLoggedIn: {
    super: "Você não está conectado",
    title: "Você precisa fazer login para ver este conteúdo",
    guest: "Convidado",
  },
  demo: {
    message:
      "Este site é uma demonstração do produto final. Atualmente, ele está em desenvolvimento e não representa um produto completo.",
    consent: "Certo!",
  },
  share: {
    header: "Compartilhe este recurso nas suas redes sociais favoritas!",
    download: "Baixar",
  },
  sharing: {
    copyURL: "Copiar link",
    copied: "Copiado",
  },
  breadCrumbs: {
    page: "Página",
  },
  onMobile: {
    header:
      "Parece que você está tentando acessar o aplicativo {appName} a partir de um dispositivo móvel",
    body: "Para baixar esse programa, acesse sua loja de aplicativos e pesquise por {appName} ou clique em um dos botões abaixo",
    benefits: {
      1: "Aprenda, promova e venda em qualquer lugar",
      2: "Treinamento multimídia em vários dispositivos",
      3: "Certificado de conclusão",
      4: "Apresentações de vendas prontas",
      5: "Materiais promocionais de alto impacto",
      6: "Diretório de produtos em tempo real",
      7: "Notícias e atualizações pontuais",
      header: "Isso fornecerá:",
    },
  },
  directory: {
    attractions: "Atrações",
    hotels: "Hotéis",
    dining: "Jantar",
    nightlife: "Vida noturna",
    artsculturehistory: "Artes, Cultura e História",
    themeparks: "Parques temáticos",
    sportsrecreationoutdoors: "Esportes, Recreação e Atividades ao ar livre",
    otheraccommodations: "Outras acomodações",
    shopping: "Compras",
    weddingservices: "Serviços de casamento",
    golf: "Golfe",
    transportationservices: "Serviços de transporte",
    spas: "Spas",
    medicalservices: "Serviços médicos",
    filters: "Filtros",
    reset: "Redefinir filtros",
    view: "Veja Agora",
    amount: "Quantidade de resultados",
    retail: "Varejo",
    accommodations: "Acomodações",
    transportation: "Transporte",
    conventionservices: "Convention Services",
    visitorprofessionalservices: "Serviços para visitantes e profissionais",
    visitorandprofessionalservices: "Serviços para visitantes e profissionais",
    studentandyouthgroupfriendly: "Amigável para grupos de estudantes e jovens",
  },
  custom: {
    splitUsers: "Eu sou...",
    brandAmbassador: "Embaixador da marca",
    travelPro: "Profissional de viagens",
  },
};
